import { render, staticRenderFns } from "./RekananList.vue?vue&type=template&id=4bc294c3"
import script from "./RekananList.vue?vue&type=script&lang=js"
export * from "./RekananList.vue?vue&type=script&lang=js"
import style0 from "./RekananList.vue?vue&type=style&index=0&id=4bc294c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports